export default __webpack_public_path__ + "resources/icons/d341-6b89.png";